// This is mostly similar to `Set`, except that it compares keys not with
// `===` but with a supplied equality function.
//
// Since it uses an array through which it searches linearly it’s not a good
// choice if there’s a large number or items, or the comparison function is
// slow.

export class ArraySet<K> {
    private readonly arr: K[] = [];

    constructor(private readonly areKeysEqual: (a: K, b: K) => boolean) {}

    public add(k: K): void {
        for (const l of this.arr) {
            if (this.areKeysEqual(k, l)) return;
        }
        this.arr.push(k);
    }

    public values(): readonly K[] {
        return this.arr;
    }
}
